<template>
  <div>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered loading"
    ></v-progress-circular>
    <div class="report-crm" :class="{ 'blur--content': isLoading }">
      <h1 class="text-center">CRM Metrics</h1>
      <FilterMetric
        :is-submit="isSubmit"
        :error="error"
        :is-show-ok-button="true"
        @filterMetrics="getProcessId"
      />
      <JobTable
        metric-type="CRM_METRICS"
        @getRequestParams="getCRMReportJobList"
        :list-job-data="listCRMJobData"
        :total-rows="totalRows"
      />
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h5 class="p-3">{{ message }}</h5>
        <div class="text-center">
          <button class="btn-back" @click="showDialog = false">ปิด</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ReportService from "services/api/report.service";
import FilterMetric from "@/views/Reports/MetricsUtils/FilterMetric.vue";
import JobTable from "@/views/Reports/MetricsUtils/JobTable.vue";
import moment from "moment/moment";

export default {
  components: { JobTable, FilterMetric },
  data() {
    return {
      isLoading: false,
      isSubmit: false,
      processId: null,
      listCRMJobData: [],
      message: null,
      showDialog: false,
      totalRows: null,
      jobRequestParams: {
        currentPage: null,
        limit: null,
        sortColumn: null,
        sortType: null,
        key: null,
        brandCode: null,
        type: null,
      },
      error: {
        errorBrand: null,
        errorDate: null,
        errorSources: null,
        errorChannel: null,
      },
    };
  },
  methods: {
    async getProcessId(form) {
      this.isSubmit = true;
      this.message = null;
      this.resetErrorText();
      const selectedSourcesKey = form.selectedSources?.map((s) => s.key);
      this.isLoading = true;
      const param = {
        brand: form.brandSelected?.id,
        date: form.dateSelect,
        isIncludeVVIP: form.isIncludeVVIP,
        channel: form.selectedChannel?.key,
        sources: selectedSourcesKey.join(","),
      };
      await ReportService.getCrmMetricsProcessId(param)
        .then(async (res) => {
          const data = res.data;
          this.processId = data.processId;
          await this.getReportJobData();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err);
          const errRes = err.response;
          const errorData = errRes?.data;
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
          }
          if (errRes.status !== 400) {
            this.isLoading = false;
            this.message =
              errRes.data?.message ||
              "An error occurred, please try again later!";
            this.showDialog = true;
          }
        });
    },
    getCRMReportJobList(params) {
      this.isLoading = true;
      this.jobRequestParams = {
        currentPage: params.currentPage,
        limit: params.limit,
        sortColumn: params.sortColumn,
        sortType: params.sortType,
        key: params.key,
        brandCode: params.brandCode,
        type: params.type,
      };
      this.getReportJobData();
    },
    getReportJobData() {
      ReportService.getReportJobs(this.jobRequestParams)
        .then((res) => {
          const data = res.data;
          this.totalRows = data.totalItems;
          this.listCRMJobData = data.reportJobs.map((c) => {
            let formattedCRMFilter = "";
            let requestCRMFilterObj = JSON.parse(c.request);
            Object.entries(requestCRMFilterObj).forEach(([key, value]) => {
              formattedCRMFilter += key + ": " + value + "\n";
            });

            return {
              ...c,
              status: this.leadWithUpperCase(c.status),
              dateCreated: moment(c.dateCreated).format("YYYY-MM-DD HH:mm:ss"),
              request: formattedCRMFilter,
            };
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    leadWithUpperCase(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    setErrorText(errors) {
      this.error.errorBrand = errors.find((e) => e.fieldName === "brand");
      this.error.errorDate = errors.find((e) => e.fieldName === "date");
      this.error.errorSources = errors.find((e) => e.fieldName === "sources");
      this.error.errorChannel = errors.find((e) => e.fieldName === "channel");
    },
    resetErrorText() {
      this.error = {
        errorBrand: null,
        errorDate: null,
        errorSources: null,
        errorChannel: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.blur--content {
  filter: blur(2px);
  pointer-events: none;
}

.loading {
  z-index: 10;
}

.content-dialog {
  height: 200px;
  background: #fff;
  padding: 10px;
  overflow-x: hidden;

  h5 {
    text-align: center;
    padding: 3rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }

  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
